import { render, staticRenderFns } from "./ReservationDayBoard.vue?vue&type=template&id=3f813cb6&scoped=true&"
import script from "./ReservationDayBoard.vue?vue&type=script&lang=js&"
export * from "./ReservationDayBoard.vue?vue&type=script&lang=js&"
import style0 from "./ReservationDayBoard.vue?vue&type=style&index=0&id=3f813cb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f813cb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSkeletonLoader,VSnackbar,VSpacer})
